import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";

import Spinner from "../Components/Spinner";
import { ToastComponent } from "../Components/ToastComponent";
import ProtocolSummaryGrid from "./ProtocolSummaryGrid";
import { protocolService } from "../../Services/protocol.service";
import { clientService } from "../../Services/client.service";
import "./protocols.css";

export default function ProtocolSummaryPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: "title", value: t("PROTOCOL_SUMMARY.TITLE") });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [regionalId, setRegionalId] = useState("TODOS");
  const [regionalOptions, setRegionalOptions] = useState([]);

  const [gridInfo, setGridInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [toastParams, setToastParams] = useState("");

  useEffect(() => {
    clientService.fetchRegionals().then(setRegionalOptions);
  }, []);

  const fetchSummary = async () => {
    setIsLoading(true);
    try {
      const result = await protocolService.fetchProtocolSummary(regionalId);
      if (result === null) {
        setToastParams(
          JSON.stringify({
            show: true,
            title: t("PROTOCOL_SUMMARY.TITLE"),
            body: t("REPORTS.ERROR_FETCHING_REPORT"),
            color: "Warning",
          })
        );
        setGridInfo([]);
      } else {
        setGridInfo(result);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const totalClients = Array.isArray(gridInfo) ? gridInfo.length : 0;
  const totalProtocols = Array.isArray(gridInfo)
    ? gridInfo.reduce((sum, item) => sum + (item.quantity ?? 0), 0)
    : 0;

  return (
    <div className="container-xxl flex-grow-1 container-p-y">
      <ToastComponent
        params={toastParams}
        closeToast={() => setToastParams(JSON.stringify({ show: false }))}
      />

      <div className="row mb-3">
        <div className="col-12 d-flex justify-content-end gap-2">
          <span className="badge bg-label-primary" style={{ fontSize: 10 }}>
            {t("PROTOCOL_SUMMARY.TOTAL_CLIENTS_LABEL")}: {totalClients}
          </span>
          <span className="badge bg-label-primary" style={{ fontSize: 10 }}>
            {t("PROTOCOL_SUMMARY.TOTAL_PROTOCOLS_LABEL")}: {totalProtocols}
          </span>
        </div>
      </div>

      <div className="row mb-4 align-items-end g-3">
        <div className="col-md-4 col-6">
          <label className="form-label" style={{ fontSize: 10 }}>
            {t("PROTOCOL_SUMMARY.FILTERS.REGIONAL")}
          </label>
          <select
            className="form-select"
            value={regionalId}
            onChange={(e) => setRegionalId(e.target.value)}
          >
            <option value="TODOS">{t("PROTOCOLS.FILTERS.ALL")}</option>
            {regionalOptions.map((option) => (
              <option key={option.regionalId} value={option.regionalId}>
                {option.regionalName}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-8 col-6 d-flex justify-content-end">
          <Button variant="outline-primary" className="text-nowrap" onClick={fetchSummary}>
            {t("PROTOCOLS.FILTERS.SEARCH_BUTTON")}
          </Button>
        </div>
      </div>

      {gridInfo && <ProtocolSummaryGrid gridData={gridInfo} />}
      <Spinner visible={isLoading} />
    </div>
  );
}
